<template>
  <div
    class="flex items-center gap-4 w-full border rounded-xl p-4 bg-white border-gray-200"
  >
    <div class="p-1 rounded-full bg-brand-50">
      <FileFive
        class="text-brand-600 w-7 h-7 p-1.5 rounded-full aspect-square bg-gray-100"
      />
    </div>
    <div class="grow flex">
      <div class="text-sm font-medium flex text-gray-700">
        {{ props.file.name }}
      </div>
    </div>
    <div class="flex gap-2">
      <div
        class="p-1 rounded-full cursor-pointer hover:bg-gray-50"
        @click="view"
        v-if="isViewable"
      >
        <Eye class="text-brand-600 w-7 h-7 p-1.5 rounded-full aspect-square" />
      </div>
      <div
        class="p-1 rounded-full cursor-pointer hover:bg-gray-50"
        @click="download"
      >
        <DownloadIcon
          class="text-brand-600 w-7 h-7 p-1.5 rounded-full aspect-square"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import DownloadIcon from "@/Tailwind/Icon/DownloadIcon.vue";
import FileFive from "@/Tailwind/Icon/FileFive.vue";
import Eye from "@/Tailwind/Icon/Eye.vue";
import { computed } from "vue";

const emit = defineEmits(["download", "view"]);

const props = defineProps({
  file: Object,
});

const isViewable = computed(() =>
  [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
    "text/plain",
  ].includes(props.file?.mime_type)
);

const download = () => emit("download");
const view = () => emit("view");
</script>
